import * as OvationsApi from 'core/ovations-api';
import RewardPackageType from 'core/ovations-api/enums/RewardPackageType';
import { mockPortalNoAccessError } from './portalNoAccessError';

const mockPortalLinks: OvationsApi.Types.PortalLink[] = [
    { id: '1', url: 'url123', text: 'text1', isEnabled: true, sortOrder: 1 },
    { id: '2', url: 'url456', text: 'text2', isEnabled: true, sortOrder: 2 },
    { id: '3', url: 'url789', text: 'text3', isEnabled: true, sortOrder: 3 },
];
const mockSocialLink: OvationsApi.Types.SocialMediaLink = { url: null, isEnabled: false };

export const mockPortal: OvationsApi.Types.Portal = {
    id: 1,
    programId: 'program-1',
    activeUrl: 'https://program-name-client-name.dev.ovations.groupo-dev.com',
    url: null,
    title: null,
    applicationInsightsInstrumentationKey: null,
    tagManagerId: null,
    enableSms: false,
    enableFutureOfferOptIn: false,
    futureOfferOptInPrompt: null,
    emailDomain: null,
    fromEmailUsername: null,
    replyToEmailAddress: null,
    smsShortcode: null,
    logo: null,
    logoUrl: null,
    favIcon: null,
    favIconUrl: null,
    font: null,
    footerText: null,
    enablePoweredByGroupOLink: false,
    footerLinks: mockPortalLinks,
    facebook: mockSocialLink,
    instagram: mockSocialLink,
    linkedIn: mockSocialLink,
    pinterest: mockSocialLink,
    twitter: mockSocialLink,
    yelp: mockSocialLink,
    youTube: mockSocialLink,
    wordPress: mockSocialLink,
    primaryButtonColor: null,
    primaryButtonHoverColor: null,
    secondaryButtonColor: null,
    secondaryButtonHoverColor: null,
    navBarColor: null,
    navLinkTextColor: null,
    navLinkHoverBackgroundColor: null,
    navLinkHoverTextColor: null,
    legacyUrl: null,
    openIdEnabled: false,
    openIdClientId: null,
    openIdAuthenticationUrl: null,
    noAccessErrorMessage: null,
    enableLiveChat: false,
    liveChatAppId: null,
    liveChatAppSecret: null,
    liveChatWidgetId: null,
    hasCurrencyRewards: false,
    hasPromotions: false,
    rewardPackageTypes: [RewardPackageType.ReloadableCAN],
    dealerRegistrationEnabled: false,
    dealerRegistrationDataSetId: null,
    dealerRegistrationColumnId: null,
    useEnglishLogo: false,
    disableManualProfileCreation: false,
    hasImportedProfiles: false,
    noAccessError: mockPortalNoAccessError,
    loginFields: [],
    samlEnabled: false,
    samlIssuer: null,
    enableTaxableIncomeForm: false,
    enableRewardShoppingCatalog: false,
    pwaSettings: { enabled: false, name: '', icon: '', iconUrl: '', iconFile: null },
    dealerRegistrationFieldLabel: '',
    enablePasswordRequired: false,
    cardActivationUrls: [],
};

export default mockPortal;
